import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { notificationLog } from '../../data/notificationLog';

const { FiPieChart } = FiIcons;

const triggerLabels = {
  not_started: 'Not Started',
  due_soon: 'Due Soon',
  overdue: 'Overdue',
  phishing_followup: 'Phishing',
  compliance_deadline: 'Compliance',
  manager_escalation: 'Escalation',
};

const colors = ['#3b82f6', '#f59e0b', '#ef4444', '#f97316', '#8b5cf6', '#0ea5e9'];

const TriggerBreakdownChart = () => {
  const triggers = Object.keys(triggerLabels);
  const counts = triggers.map(t => notificationLog.filter(n => n.trigger === t).length);

  const option = {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    series: [{
      type: 'pie', radius: ['45%', '70%'],
      data: triggers.map((t, i) => ({ name: triggerLabels[t], value: counts[i], itemStyle: { color: colors[i] } })),
      label: { show: false },
      emphasis: { label: { show: true, fontSize: 12, fontWeight: 'bold' } },
    }],
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-3">
        <SafeIcon icon={FiPieChart} className="text-violet-500" />
        <h3 className="text-sm font-semibold text-slate-700">By Trigger Type</h3>
      </div>
      <ReactECharts option={option} style={{ height: 180 }} />
      <div className="mt-3 space-y-1.5">
        {triggers.map((t, i) => (
          <div key={t} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: colors[i] }} />
              <span className="text-slate-600">{triggerLabels[t]}</span>
            </div>
            <span className="font-bold text-slate-700">{counts[i]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TriggerBreakdownChart;